import { useCallback } from "react"
import { useNavigate } from "@/v1-console/router/router.utils"
import { useAppEvent } from "@/v1-console/app/context/AppContextProvider"

export const TENANT_SWITCH_EVENT = "tenant-switch-event"

export function useOnTenantSwitch(cb: () => void) {
  useAppEvent(TENANT_SWITCH_EVENT, cb)
}

export function useNavigateOnTenantSwitch(url = "/map") {
  const navigate = useNavigate()
  useOnTenantSwitch(useCallback(() => {
    navigate(url)
  }, [
    navigate,
    url
  ]))
}
